<template>
    <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" modal header="Endre passord" style="width: 25rem">
        <form v-if="user" @submit.prevent="confirmSave">
            <div class="user-password-dialog__field">
                <label for="user-password" class="user-password-dialog__label">Nytt passord</label>
                <Password
                    inputId="user-password"
                    v-model="password"
                    :feedback="false"
                    toggleMask
                    style="width: 100%"
                    inputStyle="width: 100%"
                    :invalid="!!errors.password"
                    autofocus
                />
                <small v-if="errors.password" class="user-password-dialog__error">{{ errors.password[0] }}</small>
            </div>

            <div class="user-password-dialog__field">
                <label for="user-password-confirmation" class="user-password-dialog__label">Bekreft passord</label>
                <Password
                    inputId="user-password-confirmation"
                    v-model="passwordConfirmation"
                    :feedback="false"
                    toggleMask
                    style="width: 100%"
                    inputStyle="width: 100%"
                />
            </div>

            <div class="user-password-dialog__dialog-footer">
                <Button type="button" label="Avbryt" severity="secondary" @click="$emit('update:visible', false)" />
                <Button type="submit" label="Lagre" :loading="saving" />
            </div>
        </form>
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Password from 'primevue/password';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';

function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content;
}

export default {
    components: {
        Dialog,
        Password,
        Button,
    },
    props: {
        visible: { type: Boolean, required: true },
        user: { type: Object, default: null },
    },
    emits: ['update:visible'],
    setup() {
        return {
            toast: useToast(),
            confirm: useConfirm(),
        };
    },
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            errors: {},
            saving: false,
        };
    },
    watch: {
        visible(isVisible) {
            if (!isVisible) {
                return;
            }

            this.password = '';
            this.passwordConfirmation = '';
            this.errors = {};
        },
    },
    methods: {
        confirmSave() {
            this.confirm.require({
                message: `Er du sikker på at du vil endre passordet til ${this.user.name}?`,
                header: 'Bekreft passordendring',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Endre passord',
                rejectLabel: 'Avbryt',
                accept: () => this.save(),
            });
        },
        async save() {
            this.errors = {};
            this.saving = true;

            try {
                const response = await fetch(`/api/v1/user/${this.user.id}/password`, {
                    method: 'PUT',
                    headers: {
                        'X-CSRF-TOKEN': csrfToken(),
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        password: this.password,
                        password_confirmation: this.passwordConfirmation,
                    }),
                });

                if (response.status === 422) {
                    const data = await response.json();
                    this.errors = data.errors ?? {};
                    return;
                }

                if (!response.ok) {
                    throw new Error('request failed');
                }

                this.$emit('update:visible', false);
                this.toast.add({ severity: 'success', summary: 'Lagret', detail: 'Passordet ble endret.', life: 3000 });
            } catch (error) {
                console.error(error);
                this.toast.add({ severity: 'error', summary: 'Feil', detail: 'Kunne ikke endre passordet.', life: 3000 });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
<style scoped>
.user-password-dialog__field {
    margin-bottom: 1.25rem;
}

.user-password-dialog__label {
    display: block;
    margin-bottom: 0.5rem;
}

.user-password-dialog__error {
    color: var(--p-red-500, #e24c4c);
}

.user-password-dialog__dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}
</style>
